<template>
<div class="chapter">
<div class="inner_page">
<p class="ep">“Every girl from 18 to 80 will love SOME GIRLS DO! The best feel-good book you'll read this year!”</p><p class="eps">—JANET EVANOVICH</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SomeGirlsDo_epig-1.vue?2f55cf74